import { render } from "./finance-document-panel.vue?vue&type=template&id=08129741"
import script from "./finance-document-panel.vue?vue&type=script&lang=js"
export * from "./finance-document-panel.vue?vue&type=script&lang=js"

import "./finance-document-panel.vue?vue&type=style&index=0&id=08129741&lang=scss"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__